export class ProjectToggle {
  constructor(public id: number, public active: boolean) {}
}
